import { render, staticRenderFns } from "./Actas.vue?vue&type=template&id=1fac4163"
import script from "./Actas.vue?vue&type=script&lang=js"
export * from "./Actas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fac4163')) {
      api.createRecord('1fac4163', component.options)
    } else {
      api.reload('1fac4163', component.options)
    }
    module.hot.accept("./Actas.vue?vue&type=template&id=1fac4163", function () {
      api.rerender('1fac4163', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/Actas.vue"
export default component.exports